<!-- menu.component.html -->
<nav
  class="main-menu"
  [class.compact-menu]="hasCompactMenu"
  [class.screen-medium]="screenSize === 'medium'"
  [class.screen-small]="screenSize === 'small'"
>
  <ul class="menu-list">
    @for (item of menuItems; track $index) {
      <li
        class="menu-item"
        [class.active]="isItemActive(item)"
        [class.no-submenu]="!item.submenu || item.submenu.length === 0"
        [class.has-submenu]="item.submenu && item.submenu.length > 0"
        (mouseenter)="onMouseEnter(item)"
        (mouseleave)="onMouseLeave(item)"
      >
        <a
          [routerLink]="item.route || null"
          [class.active]="isItemActive(item)"
          (click)="navigateTo(item, $event)"
        >
          {{ item.label }}
          <span *ngIf="item.submenu" class="dropdown-arrow"> </span>
        </a>

        <!-- First level submenu -->
        <div
          *ngIf="
            (item.submenu && item.isHovered && !isMobile) ||
            (item.submenu && item.isExpanded && isMobile)
          "
          class="submenu"
          [class.no-submenu]="!item.submenu || item.submenu.length === 0"
          [class.has-submenu]="item.submenu && item.submenu.length > 0"
          [class.mobile-submenu]="isMobile"
        >
          <ul>
            @for (subItem of item.submenu; track $index) {
              <li
                class="submenu-item"
                [class.expanded]="subItem.isExpanded"
                [class.active]="isItemActive(subItem)"
                (mouseenter)="onMouseEnter(subItem)"
                (mouseleave)="onMouseLeave(subItem)"
              >
                <a
                  [routerLink]="subItem.route || null"
                  [class.active]="isItemActive(subItem)"
                  [class.has-children]="subItem.submenu"
                  (click)="navigateTo(subItem, $event)"
                >
                  {{ subItem.label }}
                  <span *ngIf="subItem.submenu" class="arrow">
                    <i
                      class="pi"
                      [ngClass]="{
                        'pi-chevron-right':
                          !isMobile || (isMobile && !subItem.isExpanded),
                        'pi-chevron-up': isMobile && subItem.isExpanded,
                      }"
                    ></i>
                  </span>
                </a>

                <!-- Second level submenu (nested) -->
                <div
                  *ngIf="
                    (subItem.submenu && subItem.isHovered && !isMobile) ||
                    (subItem.submenu && subItem.isExpanded && isMobile)
                  "
                  class="nested-submenu"
                  [class.mobile-nested-submenu]="isMobile"
                >
                  <ul>
                    @for (nestedItem of subItem.submenu; track $index) {
                      <li
                        class="nested-submenu-item"
                        [class.active]="isItemActive(nestedItem)"
                      >
                        <a
                          [routerLink]="nestedItem.route || null"
                          [class.active]="isItemActive(nestedItem)"
                          (click)="navigateTo(nestedItem, $event)"
                        >
                          {{ nestedItem.label }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              </li>
            }
          </ul>
        </div>
      </li>
    }
  </ul>
</nav>
